/**
 * Goal of this hook is to anchor popovers toward the center of the page.
 * Useful if content near the edge of the window.
 */

import type { PopoverOrigin } from '@mui/material'
import { useWindow } from './useWindow'

type LayoutDirection = 'horizontal' | 'vertical' | 'both'

export const useAnchorToCenter = (
  direction: LayoutDirection,
  anchorEl: Element | null,
) => {
  const window = useWindow()
  const { innerWidth, innerHeight } = window

  const anchorOrigin: PopoverOrigin = {
    horizontal: 'center',
    vertical: 'center',
  }

  const transformOrigin: PopoverOrigin = {
    horizontal: 'center',
    vertical: 'center',
  }

  if (!anchorEl) return anchorOrigin

  const rect = anchorEl.getBoundingClientRect()

  if (direction === 'horizontal' || direction === 'both') {
    if (rect.left > innerWidth / 2) {
      anchorOrigin.horizontal = 'left'
      transformOrigin.horizontal = 'right'
    } else {
      anchorOrigin.horizontal = 'right'
      transformOrigin.horizontal = 'left'
    }
  }

  if (direction === 'vertical' || direction === 'both') {
    if (rect.top > innerHeight / 2) {
      anchorOrigin.vertical = 'top'
      transformOrigin.vertical = 'bottom'
    } else {
      anchorOrigin.vertical = 'bottom'
      transformOrigin.vertical = 'top'
    }
  }

  return { anchorOrigin, transformOrigin }
}
